import { render, staticRenderFns } from "./brussels.vue?vue&type=template&id=7a3553a7&"
import script from "./brussels.vue?vue&type=script&lang=js&"
export * from "./brussels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports